// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sidebar_logo__sE\\+IO {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 30px 0;
}
.Sidebar_logo__sE\\+IO img {
  width: 50%;
}`, "",{"version":3,"sources":["webpack://./src/Admin/Layout/Sidebar/Sidebar.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;AACF;AAAE;EACE,UAAA;AAEJ","sourcesContent":[".logo {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  padding: 30px 0;\n  img {\n    width: 50%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logo": `Sidebar_logo__sE+IO`
};
export default ___CSS_LOADER_EXPORT___;
